import FormattedText from './FormattedText';
import RequirementForm from './RequirementForm';

import { can } from '../../../permissions';

import ConfirmButton from './ConfirmButton';
import PortalButton from './PortalButton';
import React, { useState } from 'react';
import { MdEdit, MdDelete, MdAdd } from 'react-icons/md';
import { usePortalMutation, usePortal } from '../hooks';
import { ErrorNotice, Empty } from './Feedback';

export default function RequirementManager({ selection }) {
  const { user } = usePortal();
  const allowed = can(user, 'portal_configuracoes', 'edit');
  const [editing, setEditing] = useState(null),
    [adding, setAdding] = useState(false),
    remove = usePortalMutation((d) => `selecoes/${selection.id}/requisitos/${d.id}`, 'DELETE');
  return (
    <section className="card module-card module-content">
      <div className="card-body">
        <div className="portal-admin-row">
          <h2 className="module-details-title">Documentos exigidos</h2>
          <PortalButton
            className="btn btn-success hidethis"
            disabled={!allowed}
            onClick={() => {
              setAdding(true);
              setEditing(null);
            }}
            type="button"
          >
            <MdAdd />
            Adicionar requisito
          </PortalButton>
        </div>
        <p>Configure os documentos antes de receber inscrições confirmadas.</p>
        <ErrorNotice error={remove.error} />
        {selection.document_requirements.length === 0 && <Empty>Nenhum registro encontrado.</Empty>}
        {selection.document_requirements.map((r) => (
          <div className="portal-admin-item" key={r.id}>
            <span>
              <FormattedText>{r.title}</FormattedText> · {r.required ? 'Obrigatório' : 'Opcional'} · até{' '}
              {Math.floor(r.max_kb / 1024)} MB
            </span>
            <div className="portal-admin-actions hidethis actions-group">
              <PortalButton
                title="Editar requisito"
                disabled={!allowed}
                className="btn btn-sm btn-primary"
                onClick={() => {
                  setEditing(r);
                  setAdding(false);
                }}
                type="button"
              >
                <MdEdit />
              </PortalButton>
              <ConfirmButton
                className="btn btn-sm btn-danger"
                title="Retirar requisito"
                disabled={!remove.allowed}
                type="button"
                message={'Retirar este requisito?'}
                onConfirm={() =>
                  remove.mutate({
                    id: r.id,
                  })
                }
              >
                <MdDelete />
              </ConfirmButton>
            </div>
          </div>
        ))}
        {(adding || editing) && (
          <RequirementForm
            key={editing?.id || 'new'}
            item={editing}
            selection={selection}
            onDone={() => {
              setAdding(false);
              setEditing(null);
            }}
          />
        )}
      </div>
    </section>
  );
}
